import script from "./DinamicaRBXForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./DinamicaRBXForm.vue?vue&type=script&setup=true&lang=ts"

import "./DinamicaRBXForm.vue?vue&type=style&index=0&id=1a6d6f12&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a6d6f12"]])

export default __exports__